import { render, staticRenderFns } from "./AutoCompletedInput.vue?vue&type=template&id=ae508ccc&"
import script from "./AutoCompletedInput.vue?vue&type=script&lang=js&"
export * from "./AutoCompletedInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports